module.exports = __webpack_public_path__ + "static/media/Internet_things_solutions_SDK@2x.5bc4a2a7.png";